<template lang="pug">
    d2-container(class="partnerBoard")
      el-form(:inline='true', :model='dataForm' size="mini" label-position='left' label-width="auto" label-suffix=':' )
          el-row(:span='24')
            el-col(:md='6' :sm="12")
              el-form-item(label='标题' )
                  el-input.inputWidth(v-model='dataForm.title' :placeholder="which.type === 'partner'?'合作方名称':'发布者姓名'" clearable)
            el-col(:md='6' :sm="12" v-if="which.type === 'partner'")
              el-form-item(label='类型')
                  el-select.inputWidth(v-model='dataForm.type',placeholder='请选择',clearable)
                      el-option(v-for="(item,index) in type_list",:key="index",:label="item.label",:value="item.value")
            el-col(:md='6' :sm="12" v-if="which.type === 'board'")
              el-form-item(label='状态')
                  el-select.inputWidth(v-model='dataForm.status',placeholder='请选择',clearable)
                      el-option(v-for="(item,index) in status_list",:key="index",:label="item.label",:value="item.value")
            el-col(:md='6' :sm="12")
              el-form-item(label="创建时间")
                  el-date-picker( style='width:210px;'  v-model='dataForm.publishTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
      el-row(style="padding-bottom:15px;" :span="24")
        el-col(:md='22' :sm="12" v-if="which.type === 'partner'")
          //- v-if="isAuth('pb:news:add')"
          el-button(@click='addModify()' type='primary') 新建
          el-button(@click='btn_del()' type='primary' :disabled="!btn_delStaus") 删除
        el-col(:md='2' :sm="12" style="float:right")
          el-button(@click='query()',type='primary',icon='el-icon-search',style='float:right;') 查 询
      el-table(:data="tableData" id="out-table" v-if="which.type === 'partner'" @selection-change='selectionChangeHandle' v-loading='table_loading' border)
          el-table-column( type='selection', header-align='center', align='center', width='50')
          el-table-column(prop='title' label='标题' header-align='center' align='center')
          el-table-column(prop='type' label='类型' header-align='center' align='center')
            template(slot-scope="scope")
                span() {{scope.row.type === 0?'战略合作伙伴':scope.row.type === 1?'赞助商':'供应商'}}
          el-table-column(prop='logoSort' label='LOGO顺序' header-align='center' align='center')
          el-table-column(prop='status' label='状态' header-align='center' align='center')
            template(slot-scope="scope")
                span() {{scope.row.status === 0?'停用':'启用'}}
          el-table-column(prop='createTime' label='创建日期' header-align='center' align='center')
          el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                  template(slot-scope="scope")
                    el-menu.menuPonit(:collapse="isCollapse")
                      el-submenu(index="1")
                          template(slot="title")
                              i(class="el-icon-more" style='color:#02B90D;')
                          el-menu-item-group()
                              el-menu-item(index="1-1" v-if="isAuth('pnr:info:detail')" @click="viewDetail(scope.row)") 查看详情
                              el-menu-item(index="1-2" v-if="isAuth('pnr:info:update')" @click="addModify(scope.row)") 修改
                              el-menu-item(index="1-3" v-if="isAuth('pnr:info:delete')" @click='deleteItem(scope.row)') 删除
      el-table(:data="tableData" id="out-table" v-if="which.type === 'board'" v-loading='table_loading' border)
          el-table-column(prop='name' label='发布者姓名' header-align='center' align='center')
          el-table-column(prop='content' label='内容' header-align='center' align='center')
            template(slot-scope="scope")
              el-tooltip(v-if="scope.row.content.length>30" effect="dark" :content="scope.row.content" placement="right")
                span(class="limit_content") {{scope.row.content}}
              span(class="limit_content" v-else) {{scope.row.content}}
          el-table-column(prop='status' label='状态' header-align='center' align='center')
            template(slot-scope="scope")
                span() {{scope.row.status === 1?'未审核':scope.row.status === 2?'审核通过':'审核不通过'}}
          el-table-column(prop='createTime' label='创建日期' header-align='center' align='center')
          el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                  template(slot-scope="scope")
                    el-menu.menuPonit(:collapse="isCollapse")
                      el-submenu(index="1")
                          template(slot="title")
                              i(class="el-icon-more" style='color:#02B90D;')
                          el-menu-item-group()
                              //-  v-if="isAuth('pb:news:update')"
                              el-menu-item(index="1-1" v-if="isAuth('msg:info:show')" :disabled="scope.row.status !== 1 && scope.row.status === 2" @click="show_msg(scope.row,true)") 显示
                              el-menu-item(index="1-2" v-if="isAuth('msg:info:blank')" :disabled="scope.row.status !== 1 && scope.row.status !== 2" @click="show_msg(scope.row,false)") 不显示
                              el-menu-item(index="1-3" v-if="isAuth('msg:info:detail')" @click='view_msg(scope.row)') 查看详情
      el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
      AddModify(v-show="partnerVisible" @getDataList="getDataList" ref="AddModify")
      viewDetail(v-show="viewDetailVisible" ref="viewDetail")
      ViewMsg(v-show="boardVisible" ref="ViewMsg")
</template>
<script>
import { GetMessage, Update } from '@/api/pages/news/msgBoard/index.js';
import { GetPartner, ManagePartner } from '@/api/pages/news/partner/index.js';
export default {
  props: ['which'],
  components: {
    AddModify: () => import('@/pages/news/partner/addModify.vue'),
    viewDetail: () => import('@/pages/news/partner/viewDetail.vue'),
    ViewMsg: () => import('@/pages/news/msgBoard/viewMsg.vue')
  },
  data () {
    return {
      dataForm: {
        title: null,
        type: null,
        status: null,
        publishTime: []
      },
      type_list: [
        {
          label: '战略合作伙伴',
          value: 0
        },
        {
          label: '赞助商',
          value: 1
        },
        {
          label: '供应商',
          value: 2
        }
      ],
      status_list: [
        {
          label: '未审核',
          value: 1
        },
        {
          label: '审核通过',
          value: 2
        },
        {
          label: '审核不通过',
          value: 3
        }
      ],
      tableData: [],
      delTableList: null, //多选框选中
      btn_delStaus: false, //删除按钮状态
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      isCollapse: true,
      partnerVisible: false,
      viewDetailVisible: false,
      boardVisible: false,
      table_loading: false
    };
  },
  methods: {
    addModify (row) {
      this.partnerVisible = true;
      this.$refs.AddModify.init(row);
    },
    viewDetail (row) {
      this.viewDetailVisible = true;
      this.$refs.viewDetail.init(row);
    },
    btn_del () {
      let list = this.delTableList.map(item => {
        let obj = { id: item.id };
        return obj;
      });
      let info = {
        list,
        tip: '此操作将永久删除已选中合作方信息, 是否继续?'
      };
      this.tip(info);
    },
    getDataList () {
      let which_type = this.which.type;
      let { title, type, status, publishTime } = this.dataForm;
      this.table_loading = true;
      switch (which_type) {
        case 'partner':
          let params = {
            rows: this.pageSize,
            pageNo: this.pageIndex,
            name: title,
            type,
            startTime: publishTime && publishTime.length > 0 ? publishTime[0] : null,
            endTime: publishTime && publishTime.length > 0 ? publishTime[1] : null
          };
          GetPartner(params).then(res => {
            if (res.code === 0) {
              let { size, total, records, current } = res.data;
              this.pageIndex = current;
              this.pageSize = size;
              this.totalPage = total;
              this.tableData = records;
              this.table_loading = false;
            }
          });
          break;
        case 'board':
          let data = {
            rows: this.pageSize,
            pageNo: this.pageIndex,
            name: title,
            status,
            startTime: publishTime && publishTime.length > 0 ? publishTime[0] : null,
            endTime: publishTime && publishTime.length > 0 ? publishTime[1] : null
          };
          GetMessage(data).then(res => {
            if (res.code === 0) {
              let { size, total, records, current } = res.data;
              this.pageIndex = current;
              this.pageSize = size;
              this.totalPage = total;
              this.tableData = records;
              this.table_loading = false;
            }
          });
          break;
        default:
          break;
      }
    },
    deleteItem (row) {
      let arr = [];
      let obj = { id: row.id };
      arr.push(obj);
      let info = {
        list: arr,
        tip: '此操作将永久删除该合作方信息, 是否继续?'
      };
      this.tip(info);
    },
    show_msg (row, status) {
      let params = {
        messageId: row.id,
        status: status ? 2 : 3
      };
      Update(params).then(res => {
        this.getDataList();
      });
    },
    view_msg (row) {
      this.boardVisible = true;
      this.$refs.ViewMsg.init(row);
    },
    tip (info) {
      let { tip, list } = info;
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          flag: 1,
          partners: list
        };
        ManagePartner(data).then(res => {
          this.getDataList();
        });
      });
    },
    query () {
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList();
    },
    // table多选框选中
    selectionChangeHandle (val) {
      this.delTableList = val;
      this.btn_delStaus = !!this.delTableList.length;
    },
    // 分页器
    currentChangeHandle (val) {
      this.pageIndex = val;
      this.getDataList();
    },
    sizeChangeHandle (val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    }
  },
  created () {
    this.getDataList();
  }
};
</script>
<style>
/* 操作三点 菜单样式 */
@import '../../css/opr3dot.css';
.el-tooltip__popper {
  max-width: 400px;
}
</style>
<style lang="scss" scoped>
.limit_content {
  overflow: hidden;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  text-overflow: ellipsis;
}
</style>
